import axios from "axios";

export default axios.create({
  baseURL: import.meta.env.VITE_QUESTIONNAIRE_MANAGER_ENDPOINT,
});
